import { Button, Popover, Position } from "@blueprintjs/core"
import { Link } from "react-router-dom"
import ConfirmButton from "src/libs/useful/ConfirmButton"
import { LoaderMinimal } from "src/libs/useful/Loading"
import { __ } from "src/libs/utilities"
import { getDownload } from "src/libs/utilities/getDownloadFile"
import * as XLSX from 'xlsx'
import { getAnswerCategoryData, getCVGData } from "../../data/utils/getCVGData"
import useTest from "../../hooks/useTest"
import { IPost } from "src/libs/interfaces/layouts"
import { useDataStore } from "src/modules/pe-basic-module/data/store"

/* Protopia Ecosystem component */
export interface IUserResultButtonProps {
    item: any 
    params: any
}
const UserResultButton = ({ item, params }: IUserResultButtonProps): JSX.Element => { 
    // console.log( params )
    const PETestCategory : IPost[] = useDataStore((state: any) => state.PETestCategory)
    const test = useTest( item.test_id )
    const onRemove = () => { 
        item.onRemove( item.ID )
    }
    const onDownload = () => {
        let cats : any[] = []
        const csvData = getAnswerCategoryData(item.results, test)
        console.log( item, csvData )
        const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
        const fileExtension = '.xlsx'
        const testTitle = test.title 
        const userName =  item.user.display_name 
        const name = userName + "_" + testTitle
        
        csvData.forEach(c => {
            if(!cats[ c.cat_id ]) {
                cats[ c.cat_id ] = { 
                    [__("Answer")]: PETestCategory.find(tc => tc.id === c.cat_id)?.title || c.cat_id, 
                    [__("Value")] : 0
                }
            }
            cats[ c.cat_id ][__("Value")] += Number(c.value)
        })
        cats = cats.filter( c => !!c)
        // console.log( cats )
        const ws = XLSX.utils.json_to_sheet( cats ) 
        const wb = { Sheets: { [testTitle]: ws }, SheetNames: [testTitle] }
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' })
        const data = new Blob([excelBuffer], {type: fileType})
        getDownload(data, "testResult_" + userName + fileExtension)
    }
    return <div className="d-flex strob01" > 
        <Link to={ `${item.test_id}` } className="d-flex w-100 flex-grow-100">
            <Button fill minimal className="p-3 btn-stretch text-uppercase " alignText="left">
                { test?.title || <LoaderMinimal /> }
            </Button>  
        </Link>
        <ConfirmButton 
            buttonMinimal  
            onConfirm={ onRemove } 
            buttonClassName=" h-50 "
            buttonLabel={<i className="far fa-trash-alt fa-1x my-2 mx-1 opacity_75"></i>}
            confirm={__("Remove this test result finally?")}
            isPopover
            popover={<div className="p-3 letter-spacing-2">{__("Remove")}</div>}
            popoverPosition={Position.TOP_RIGHT}
        />
        <Popover
            interactionKind="hover"
            position={Position.TOP_RIGHT}
            content={
                <div className="p-3 letter-spacing-2">
                    {__("Download XLS")}
                </div>
            }
        >
            <Button minimal onClick={ onDownload }  className="h-50">
                <i className="far fa-file-excel fa-1x my-2 mx-1 opacity_75"></i>
            </Button>
        </Popover>
    </div>
}
export default UserResultButton

